import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppContent as App } from "../App";
import { ErrorBoundary } from "../components/common";
import {
  BillingPage,
  CourseDetailsPage,
  CreatePasswordPage,
  Dashboard,
  LoginPage,
  OTPVerificationPage,
  PrivacyPage,
  Profile,
  ReadingPage,
  SignupPage,
  TermsPage,
  TopicsPage,
  UserDetails,
  MyCoursesPage,
} from "../pages";
import HomePage           from "../pages/HomePage";
import AllCoursesPage     from "../pages/AllCoursesPage";
import AboutUsPage        from "../pages/AboutUsPage";
import ContactUsPage      from "../pages/ContactUsPage";
import FeedbackPage       from "../pages/FeedbackPage";
import CareerPage         from "../pages/CareerPage";
import StudyAbroadPage    from "../pages/StudyAbroadPage";
import LingualServicesPage from "../pages/LingualServicesPage";
import { useAuthStore } from "../stores";
import { PrivateRoute, ProfileRequiredRoute, PublicRoute } from "./";

const Root = () => {
  const { currentUser, isAuthenticated } = useAuthStore.getState();

  const getRedirectPath = () => {
    if (!isAuthenticated) {
      return "/login";
    }
    const isProfileComplete = currentUser?.is_profile_set === true;
    return isProfileComplete ? "/dashboard" : "/user-details";
  };

  return <App />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "all-courses",
        element: <AllCoursesPage />,
      },
      {
        path: "about-us",
        element: <AboutUsPage />,
      },
      {
        path: "contact-us",
        element: <ContactUsPage />,
      },
      {
        path: "feedback",
        element: <FeedbackPage />,
      },
      {
        path: "career",
        element: <CareerPage />,
      },
      {
        path: "study-abroad",
        element: <StudyAbroadPage />,
      },
      {
        path: "lingual-services",
        element: <LingualServicesPage />,
      },
      {
        path: "login",
        element: (
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        ),
      },
      {
        path: "privacy",
        element: (
          <PublicRoute>
            <PrivacyPage />
          </PublicRoute>
        ),
      },
      {
        path: "terms",
        element: (
          <PublicRoute>
            <TermsPage />
          </PublicRoute>
        ),
      },
      {
        path: "signup",
        element: (
          <PublicRoute>
            <SignupPage />
          </PublicRoute>
        ),
      },
      {
        path: "otp-verification",
        element: (
          <PublicRoute>
            <OTPVerificationPage />
          </PublicRoute>
        ),
      },
      {
        path: "set-password",
        element: (
          <PublicRoute>
            <CreatePasswordPage />
          </PublicRoute>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <PublicRoute>
            <SignupPage mode="forgot-password" />
          </PublicRoute>
        ),
      },
      {
        path: "user-details",
        element: (
          <PrivateRoute>
            <UserDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "dashboard",
        element: (
          <ProfileRequiredRoute>
            <Dashboard />
          </ProfileRequiredRoute>
        ),
      },
      {
        path: "profile",
        element: (
          <ProfileRequiredRoute>
            <Profile />
          </ProfileRequiredRoute>
        ),
      },
      {
        path: "course/:courseId",
        element: (
          <PrivateRoute>
            <CourseDetailsPage />
          </PrivateRoute>
        ),
      },
      {
        path: "topics/:courseId",
        element: (
          <ProfileRequiredRoute>
            <TopicsPage />
          </ProfileRequiredRoute>
        ),
      },
      {
        path: "reading",
        element: (
          <ProfileRequiredRoute>
            <ReadingPage />
          </ProfileRequiredRoute>
        ),
      },
      {
        path: "billing",
        element: (
          <ProfileRequiredRoute>
            <BillingPage />
          </ProfileRequiredRoute>
        ),
      },
      {
        path: "my-courses",
        element: (
          <ProfileRequiredRoute>
            <MyCoursesPage />
          </ProfileRequiredRoute>
        ),
      },
    ],
  },
]);

export default router;